// I'd rather not have up-source attributes on my meta tags, so remove them again
up.compiler('meta, link', (element: HTMLElement) => {
  element.removeAttribute('up-source')
})
